import { axiosClient } from './axios_client';

/**
 * API client cho Project Management
 */

/**
 * Lấy danh sách tất cả projects
 */
export const getAllProjects = async (filters = {}) => {
  try {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.created_by) params.append('created_by', filters.created_by);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);

    const response = await axiosClient.get(`/api/projects?${params.toString()}`);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Lấy thông tin một project theo ID
 */
export const getProjectById = async (id) => {
  try {
    const response = await axiosClient.get(`/api/projects/${id}`);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Tạo project mới
 */
export const createProject = async (projectData) => {
  try {
    const response = await axiosClient.post('/api/projects', projectData);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Cập nhật project
 */
export const updateProject = async (id, projectData) => {
  try {
    const response = await axiosClient.put(`/api/projects/${id}`, projectData);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Xóa project
 */
export const deleteProject = async (id) => {
  try {
    const response = await axiosClient.delete(`/api/projects/${id}`);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Lấy danh sách inverters của project
 */
export const getProjectInverters = async (projectId) => {
  try {
    const response = await axiosClient.get(`/api/projects/${projectId}/inverters`);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Thêm inverter vào project
 */
export const addInverterToProject = async (projectId, inverterId) => {
  try {
    const response = await axiosClient.post(`/api/projects/${projectId}/inverters`, {
      inverter_id: inverterId
    });
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

/**
 * Xóa inverter khỏi project
 */
export const removeInverterFromProject = async (projectId, inverterId) => {
  try {
    const response = await axiosClient.delete(`/api/projects/${projectId}/inverters/${inverterId}`);
    // axiosClient interceptor đã trả về response.data rồi
    return response;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const project_api = {
  getAllProjects,
  getProjectById,
  createProject,
  updateProject,
  deleteProject,
  getProjectInverters,
  addInverterToProject,
  removeInverterFromProject
};

